export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 7_07.47f494ae.jpg";